import { TootActions } from "../../../layout/components/TootActions/TootActions";
import { TootHeading } from "../../../layout/components/TootHeading/TootHeading";
import { TootSectionShell } from "../../../layout/components/TootSectionShell/TootSectionShell";
import { TootMediaFrame } from "../../../surface/components/TootMediaFrame/TootMediaFrame";
import type { ITootHeroSplitImageProps } from "./TootHeroSplitImage.props";

export const TootHeroSplitImage = ({
  alignment,
  anchorId,
  buttons,
  eyebrow,
  heading,
  image,
  parentClass,
  priority,
  spacing,
  subheading,
}: ITootHeroSplitImageProps) => {
  const headingAlignment = alignment === "center" ? "center" : "left";

  return (
    <TootSectionShell
      className="relative grid items-center gap-10 overflow-hidden lg:grid-cols-[minmax(0,0.88fr)_minmax(28rem,1.12fr)]"
      containerClassName="relative"
      id={anchorId ?? undefined}
      rootClassName={parentClass}
      spacing={spacing ?? undefined}
      tone="dark"
      width="wide"
    >
      <div className="relative z-10">
        <div className="toot-hero-split-copy relative z-10 flex flex-col gap-8">
          <TootHeading
            actions={
              buttons?.length ? (
                <TootActions actions={buttons} alignment={headingAlignment} />
              ) : null
            }
            alignment={headingAlignment}
            as="h1"
            eyebrow={eyebrow}
            heading={heading}
            size="hero"
            subheading={subheading}
          />
        </div>
      </div>
      <div className="toot-hero-split-media-shell relative z-10">
        {image ? (
          <TootMediaFrame
            alt={image.alternateText}
            aspectRatio="16 / 10"
            caption={image.caption}
            className="toot-hero-split-media"
            focalPoint={image.focalPoint ?? undefined}
            height={image.height ?? undefined}
            loading={priority ? "eager" : "lazy"}
            sizes={image.sizes ?? "(min-width: 1024px) 50vw, 100vw"}
            src={image.defaultSrc}
            srcSet={image.srcSet ?? undefined}
            width={image.width ?? undefined}
          />
        ) : null}
      </div>
    </TootSectionShell>
  );
};

TootHeroSplitImage.displayName = "Content::TootHeroSplitImage";
